window.ICeFinderModels = [
  {
    "id": "model-1",
    "brand": "XIAOMI",
    "name": "M365",
    "label": "XIAOMI M365",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "M365 / 1S / Essential",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-2",
    "brand": "XIAOMI",
    "name": "1S",
    "label": "XIAOMI 1S",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "M365 / 1S / Essential",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-3",
    "brand": "XIAOMI",
    "name": "Essential",
    "label": "XIAOMI Essential",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "M365 / 1S / Essential",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-4",
    "brand": "XIAOMI",
    "name": "Mi Pro",
    "label": "XIAOMI Mi Pro",
    "foldedMin": 113,
    "foldedMax": 113,
    "unfoldedMax": null,
    "sourceGroup": "Mi Pro / Pro 2",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-5",
    "brand": "XIAOMI",
    "name": "Pro 2",
    "label": "XIAOMI Pro 2",
    "foldedMin": 113,
    "foldedMax": 113,
    "unfoldedMax": null,
    "sourceGroup": "Mi Pro / Pro 2",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-6",
    "brand": "XIAOMI",
    "name": "Electric Scooter 3",
    "label": "XIAOMI Electric Scooter 3",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "Electric Scooter 3 / 3 Lite",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-7",
    "brand": "XIAOMI",
    "name": "Electric Scooter 3 Lite",
    "label": "XIAOMI Electric Scooter 3 Lite",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "Electric Scooter 3 / 3 Lite",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-8",
    "brand": "XIAOMI",
    "name": "Electric Scooter 4",
    "label": "XIAOMI Electric Scooter 4",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "Electric Scooter 4 / 4 Lite",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-9",
    "brand": "XIAOMI",
    "name": "Electric Scooter 4 Lite",
    "label": "XIAOMI Electric Scooter 4 Lite",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "Electric Scooter 4 / 4 Lite",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-10",
    "brand": "XIAOMI",
    "name": "Electric Scooter 4 Pro",
    "label": "XIAOMI Electric Scooter 4 Pro",
    "foldedMin": 117,
    "foldedMax": 117,
    "unfoldedMax": null,
    "sourceGroup": "Electric Scooter 4 Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-11",
    "brand": "XIAOMI",
    "name": "Electric Scooter 4 Ultra",
    "label": "XIAOMI Electric Scooter 4 Ultra",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "Electric Scooter 4 Ultra",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-12",
    "brand": "SEGWAY-NINEBOT",
    "name": "E22",
    "label": "SEGWAY-NINEBOT E22",
    "foldedMin": 102,
    "foldedMax": 102,
    "unfoldedMax": null,
    "sourceGroup": "E22 / E25",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-13",
    "brand": "SEGWAY-NINEBOT",
    "name": "E25",
    "label": "SEGWAY-NINEBOT E25",
    "foldedMin": 102,
    "foldedMax": 102,
    "unfoldedMax": null,
    "sourceGroup": "E22 / E25",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-14",
    "brand": "SEGWAY-NINEBOT",
    "name": "ES1",
    "label": "SEGWAY-NINEBOT ES1",
    "foldedMin": 113,
    "foldedMax": 113,
    "unfoldedMax": null,
    "sourceGroup": "ES1 / ES2 / ES4",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-15",
    "brand": "SEGWAY-NINEBOT",
    "name": "ES2",
    "label": "SEGWAY-NINEBOT ES2",
    "foldedMin": 113,
    "foldedMax": 113,
    "unfoldedMax": null,
    "sourceGroup": "ES1 / ES2 / ES4",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-16",
    "brand": "SEGWAY-NINEBOT",
    "name": "ES4",
    "label": "SEGWAY-NINEBOT ES4",
    "foldedMin": 113,
    "foldedMax": 113,
    "unfoldedMax": null,
    "sourceGroup": "ES1 / ES2 / ES4",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-17",
    "brand": "SEGWAY-NINEBOT",
    "name": "F25",
    "label": "SEGWAY-NINEBOT F25",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "F25 / F30 / F40 / F2 Pro / E45 / D-series",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-18",
    "brand": "SEGWAY-NINEBOT",
    "name": "F30",
    "label": "SEGWAY-NINEBOT F30",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "F25 / F30 / F40 / F2 Pro / E45 / D-series",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-19",
    "brand": "SEGWAY-NINEBOT",
    "name": "F40",
    "label": "SEGWAY-NINEBOT F40",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "F25 / F30 / F40 / F2 Pro / E45 / D-series",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-20",
    "brand": "SEGWAY-NINEBOT",
    "name": "F2 Pro",
    "label": "SEGWAY-NINEBOT F2 Pro",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "F25 / F30 / F40 / F2 Pro / E45 / D-series",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-21",
    "brand": "SEGWAY-NINEBOT",
    "name": "E45",
    "label": "SEGWAY-NINEBOT E45",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "F25 / F30 / F40 / F2 Pro / E45 / D-series",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-22",
    "brand": "SEGWAY-NINEBOT",
    "name": "D-series",
    "label": "SEGWAY-NINEBOT D-series",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "F25 / F30 / F40 / F2 Pro / E45 / D-series",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-23",
    "brand": "SEGWAY-NINEBOT",
    "name": "Max G30",
    "label": "SEGWAY-NINEBOT Max G30",
    "foldedMin": 117,
    "foldedMax": 117,
    "unfoldedMax": null,
    "sourceGroup": "Max G30",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-24",
    "brand": "SEGWAY-NINEBOT",
    "name": "Max G2",
    "label": "SEGWAY-NINEBOT Max G2",
    "foldedMin": 121,
    "foldedMax": 121,
    "unfoldedMax": null,
    "sourceGroup": "Max G2",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-25",
    "brand": "SEGWAY-NINEBOT",
    "name": "GT1",
    "label": "SEGWAY-NINEBOT GT1",
    "foldedMin": 124,
    "foldedMax": 124,
    "unfoldedMax": null,
    "sourceGroup": "GT1",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-26",
    "brand": "SEGWAY-NINEBOT",
    "name": "GT2",
    "label": "SEGWAY-NINEBOT GT2",
    "foldedMin": 130,
    "foldedMax": 130,
    "unfoldedMax": null,
    "sourceGroup": "GT2",
    "aliases": [
      "Segway",
      "Ninebot"
    ],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-27",
    "brand": "CECOTEC BONGO",
    "name": "Serie A",
    "label": "CECOTEC BONGO Serie A",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "Serie A",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-28",
    "brand": "CECOTEC BONGO",
    "name": "Serie Z",
    "label": "CECOTEC BONGO Serie Z",
    "foldedMin": 119,
    "foldedMax": 119,
    "unfoldedMax": null,
    "sourceGroup": "Serie Z / M / S",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-29",
    "brand": "CECOTEC BONGO",
    "name": "Serie M",
    "label": "CECOTEC BONGO Serie M",
    "foldedMin": 119,
    "foldedMax": 119,
    "unfoldedMax": null,
    "sourceGroup": "Serie Z / M / S",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-30",
    "brand": "CECOTEC BONGO",
    "name": "Serie S",
    "label": "CECOTEC BONGO Serie S",
    "foldedMin": 119,
    "foldedMax": 119,
    "unfoldedMax": null,
    "sourceGroup": "Serie Z / M / S",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-31",
    "brand": "SMARTGYRO",
    "name": "Speedway",
    "label": "SMARTGYRO Speedway",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "Speedway",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-32",
    "brand": "SMARTGYRO",
    "name": "Crossover",
    "label": "SMARTGYRO Crossover",
    "foldedMin": 119,
    "foldedMax": 119,
    "unfoldedMax": null,
    "sourceGroup": "Crossover / Rockway / K2",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-33",
    "brand": "SMARTGYRO",
    "name": "Rockway",
    "label": "SMARTGYRO Rockway",
    "foldedMin": 119,
    "foldedMax": 119,
    "unfoldedMax": null,
    "sourceGroup": "Crossover / Rockway / K2",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-34",
    "brand": "SMARTGYRO",
    "name": "K2",
    "label": "SMARTGYRO K2",
    "foldedMin": 119,
    "foldedMax": 119,
    "unfoldedMax": null,
    "sourceGroup": "Crossover / Rockway / K2",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-35",
    "brand": "SMARTGYRO",
    "name": "Raptor",
    "label": "SMARTGYRO Raptor",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "Raptor",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-36",
    "brand": "NIU",
    "name": "KQi2 Pro",
    "label": "NIU KQi2 Pro",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "KQi2 Pro / KQi3 Pro / KQi3 Max / KQi Air",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-37",
    "brand": "NIU",
    "name": "KQi3 Pro",
    "label": "NIU KQi3 Pro",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "KQi2 Pro / KQi3 Pro / KQi3 Max / KQi Air",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-38",
    "brand": "NIU",
    "name": "KQi3 Max",
    "label": "NIU KQi3 Max",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "KQi2 Pro / KQi3 Pro / KQi3 Max / KQi Air",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-39",
    "brand": "NIU",
    "name": "KQi Air",
    "label": "NIU KQi Air",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "KQi2 Pro / KQi3 Pro / KQi3 Max / KQi Air",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-40",
    "brand": "NIU",
    "name": "KQi Air X",
    "label": "NIU KQi Air X",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "KQi Air X",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-41",
    "brand": "PURE ELECTRIC",
    "name": "Air",
    "label": "PURE ELECTRIC Air",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "Air / Air Pro / Air3",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-42",
    "brand": "PURE ELECTRIC",
    "name": "Air Pro",
    "label": "PURE ELECTRIC Air Pro",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "Air / Air Pro / Air3",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-43",
    "brand": "PURE ELECTRIC",
    "name": "Air3",
    "label": "PURE ELECTRIC Air3",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": null,
    "sourceGroup": "Air / Air Pro / Air3",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-44",
    "brand": "PURE ELECTRIC",
    "name": "Advance",
    "label": "PURE ELECTRIC Advance",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "Advance / Advance+",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-45",
    "brand": "PURE ELECTRIC",
    "name": "Advance+",
    "label": "PURE ELECTRIC Advance+",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "Advance / Advance+",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-46",
    "brand": "HIBOY",
    "name": "S2",
    "label": "HIBOY S2",
    "foldedMin": 109,
    "foldedMax": 109,
    "unfoldedMax": null,
    "sourceGroup": "S2 / S2 Pro / S2 Max",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-47",
    "brand": "HIBOY",
    "name": "S2 Pro",
    "label": "HIBOY S2 Pro",
    "foldedMin": 109,
    "foldedMax": 109,
    "unfoldedMax": null,
    "sourceGroup": "S2 / S2 Pro / S2 Max",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-48",
    "brand": "HIBOY",
    "name": "S2 Max",
    "label": "HIBOY S2 Max",
    "foldedMin": 109,
    "foldedMax": 109,
    "unfoldedMax": null,
    "sourceGroup": "S2 / S2 Pro / S2 Max",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-49",
    "brand": "HIBOY",
    "name": "KS4 Pro",
    "label": "HIBOY KS4 Pro",
    "foldedMin": 119,
    "foldedMax": 119,
    "unfoldedMax": null,
    "sourceGroup": "KS4 Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-50",
    "brand": "HIBOY",
    "name": "Titan Pro",
    "label": "HIBOY Titan Pro",
    "foldedMin": 124,
    "foldedMax": 124,
    "unfoldedMax": null,
    "sourceGroup": "Titan Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-51",
    "brand": "JOYOR",
    "name": "X1",
    "label": "JOYOR X1",
    "foldedMin": 110,
    "foldedMax": 110,
    "unfoldedMax": null,
    "sourceGroup": "X1",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-52",
    "brand": "JOYOR",
    "name": "X5S",
    "label": "JOYOR X5S",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "X5S / X9 / Y9 / S5 / S8 / S10",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-53",
    "brand": "JOYOR",
    "name": "X9",
    "label": "JOYOR X9",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "X5S / X9 / Y9 / S5 / S8 / S10",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-54",
    "brand": "JOYOR",
    "name": "Y9",
    "label": "JOYOR Y9",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "X5S / X9 / Y9 / S5 / S8 / S10",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-55",
    "brand": "JOYOR",
    "name": "S5",
    "label": "JOYOR S5",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "X5S / X9 / Y9 / S5 / S8 / S10",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-56",
    "brand": "JOYOR",
    "name": "S8",
    "label": "JOYOR S8",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "X5S / X9 / Y9 / S5 / S8 / S10",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-57",
    "brand": "JOYOR",
    "name": "S10",
    "label": "JOYOR S10",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "X5S / X9 / Y9 / S5 / S8 / S10",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-58",
    "brand": "INOKIM",
    "name": "Light 2",
    "label": "INOKIM Light 2",
    "foldedMin": 110,
    "foldedMax": 110,
    "unfoldedMax": null,
    "sourceGroup": "Light 2",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-59",
    "brand": "INOKIM",
    "name": "Quick 4",
    "label": "INOKIM Quick 4",
    "foldedMin": 119,
    "foldedMax": 119,
    "unfoldedMax": null,
    "sourceGroup": "Quick 4",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-60",
    "brand": "INOKIM",
    "name": "OX",
    "label": "INOKIM OX",
    "foldedMin": 124,
    "foldedMax": 124,
    "unfoldedMax": null,
    "sourceGroup": "OX / OXO",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-61",
    "brand": "INOKIM",
    "name": "OXO",
    "label": "INOKIM OXO",
    "foldedMin": 124,
    "foldedMax": 124,
    "unfoldedMax": null,
    "sourceGroup": "OX / OXO",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-62",
    "brand": "KUGOO",
    "name": "S1",
    "label": "KUGOO S1",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "S1 / S2 / S3",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-63",
    "brand": "KUGOO",
    "name": "S2",
    "label": "KUGOO S2",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "S1 / S2 / S3",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-64",
    "brand": "KUGOO",
    "name": "S3",
    "label": "KUGOO S3",
    "foldedMin": 108,
    "foldedMax": 108,
    "unfoldedMax": null,
    "sourceGroup": "S1 / S2 / S3",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-65",
    "brand": "KUGOO",
    "name": "M4",
    "label": "KUGOO M4",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "M4 / M4 Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-66",
    "brand": "KUGOO",
    "name": "M4 Pro",
    "label": "KUGOO M4 Pro",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "M4 / M4 Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-67",
    "brand": "KUGOO",
    "name": "G-Booster",
    "label": "KUGOO G-Booster",
    "foldedMin": 125,
    "foldedMax": 125,
    "unfoldedMax": null,
    "sourceGroup": "G-Booster / G2 Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-68",
    "brand": "KUGOO",
    "name": "G2 Pro",
    "label": "KUGOO G2 Pro",
    "foldedMin": 125,
    "foldedMax": 125,
    "unfoldedMax": null,
    "sourceGroup": "G-Booster / G2 Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-69",
    "brand": "DUALTRON",
    "name": "Mini",
    "label": "DUALTRON Mini",
    "foldedMin": 105,
    "foldedMax": 105,
    "unfoldedMax": null,
    "sourceGroup": "Mini",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-70",
    "brand": "DUALTRON",
    "name": "Victor",
    "label": "DUALTRON Victor",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "Victor / Eagle Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null,
    "fitExclusions": [
      "S1"
    ],
    "fitExclusionSource": "Prueba física comunicada por Oscar el 8 de septiembre de 2026: Dualtron Victor no cabe en S1; no extrapolar a otras variantes."
  },
  {
    "id": "model-71",
    "brand": "DUALTRON",
    "name": "Eagle Pro",
    "label": "DUALTRON Eagle Pro",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "Victor / Eagle Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-72",
    "brand": "DUALTRON",
    "name": "Thunder",
    "label": "DUALTRON Thunder",
    "foldedMin": 130,
    "foldedMax": 130,
    "unfoldedMax": null,
    "sourceGroup": "Thunder / Storm",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-73",
    "brand": "DUALTRON",
    "name": "Storm",
    "label": "DUALTRON Storm",
    "foldedMin": 130,
    "foldedMax": 130,
    "unfoldedMax": null,
    "sourceGroup": "Thunder / Storm",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-74",
    "brand": "DUALTRON",
    "name": "X",
    "label": "DUALTRON X",
    "foldedMin": 145,
    "foldedMax": 145,
    "unfoldedMax": null,
    "sourceGroup": "X / X2 / Ultra",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-75",
    "brand": "DUALTRON",
    "name": "X2",
    "label": "DUALTRON X2",
    "foldedMin": 145,
    "foldedMax": 145,
    "unfoldedMax": null,
    "sourceGroup": "X / X2 / Ultra",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-76",
    "brand": "DUALTRON",
    "name": "Ultra",
    "label": "DUALTRON Ultra",
    "foldedMin": 145,
    "foldedMax": 145,
    "unfoldedMax": null,
    "sourceGroup": "X / X2 / Ultra",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-77",
    "brand": "KAABO",
    "name": "Mantis 8",
    "label": "KAABO Mantis 8",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "Mantis 8 / 10",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-78",
    "brand": "KAABO",
    "name": "10",
    "label": "KAABO 10",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "Mantis 8 / 10",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-79",
    "brand": "KAABO",
    "name": "Wolf Warrior 11",
    "label": "KAABO Wolf Warrior 11",
    "foldedMin": 132,
    "foldedMax": 132,
    "unfoldedMax": null,
    "sourceGroup": "Wolf Warrior 11",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-80",
    "brand": "KAABO",
    "name": "Wolf King GT",
    "label": "KAABO Wolf King GT",
    "foldedMin": 137,
    "foldedMax": 137,
    "unfoldedMax": null,
    "sourceGroup": "Wolf King GT / GT Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-81",
    "brand": "KAABO",
    "name": "GT Pro",
    "label": "KAABO GT Pro",
    "foldedMin": 137,
    "foldedMax": 137,
    "unfoldedMax": null,
    "sourceGroup": "Wolf King GT / GT Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-82",
    "brand": "APOLLO",
    "name": "City",
    "label": "APOLLO City",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "City / City Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-83",
    "brand": "APOLLO",
    "name": "City Pro",
    "label": "APOLLO City Pro",
    "foldedMin": 120,
    "foldedMax": 120,
    "unfoldedMax": null,
    "sourceGroup": "City / City Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-84",
    "brand": "APOLLO",
    "name": "Ghost",
    "label": "APOLLO Ghost",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "Ghost / Phantom",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-85",
    "brand": "APOLLO",
    "name": "Phantom",
    "label": "APOLLO Phantom",
    "foldedMin": 122,
    "foldedMax": 122,
    "unfoldedMax": null,
    "sourceGroup": "Ghost / Phantom",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-86",
    "brand": "Riley",
    "name": "RS3",
    "label": "Riley RS3",
    "foldedMin": 119,
    "foldedMax": 119,
    "unfoldedMax": null,
    "sourceGroup": "Riley RS3",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-87",
    "brand": "Cityblitz",
    "name": "CB064SZ",
    "label": "Cityblitz CB064SZ",
    "foldedMin": 110,
    "foldedMax": 110,
    "unfoldedMax": null,
    "sourceGroup": "Cityblitz CB064SZ / Moove",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-88",
    "brand": "Cityblitz",
    "name": "Moove",
    "label": "Cityblitz Moove",
    "foldedMin": 110,
    "foldedMax": 110,
    "unfoldedMax": null,
    "sourceGroup": "Cityblitz CB064SZ / Moove",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-89",
    "brand": "iScooter",
    "name": "i9",
    "label": "iScooter i9",
    "foldedMin": 108,
    "foldedMax": 110,
    "unfoldedMax": null,
    "sourceGroup": "iScooter i9 / i10 Max",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-90",
    "brand": "iScooter",
    "name": "i10 Max",
    "label": "iScooter i10 Max",
    "foldedMin": 108,
    "foldedMax": 110,
    "unfoldedMax": null,
    "sourceGroup": "iScooter i9 / i10 Max",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-91",
    "brand": "Turboant",
    "name": "X7 Pro",
    "label": "Turboant X7 Pro",
    "foldedMin": 113,
    "foldedMax": 113,
    "unfoldedMax": null,
    "sourceGroup": "Turboant X7 Pro",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-92",
    "brand": "Turboant",
    "name": "M10 Lite",
    "label": "Turboant M10 Lite",
    "foldedMin": 109,
    "foldedMax": 109,
    "unfoldedMax": null,
    "sourceGroup": "Turboant M10 Lite",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-93",
    "brand": "E-Twow",
    "name": "Booster S+",
    "label": "E-Twow Booster S+",
    "foldedMin": 95,
    "foldedMax": 100,
    "unfoldedMax": null,
    "sourceGroup": "E-Twow Booster S+ / GT / SE",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-94",
    "brand": "E-Twow",
    "name": "GT",
    "label": "E-Twow GT",
    "foldedMin": 95,
    "foldedMax": 100,
    "unfoldedMax": null,
    "sourceGroup": "E-Twow Booster S+ / GT / SE",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "id": "model-95",
    "brand": "E-Twow",
    "name": "SE",
    "label": "E-Twow SE",
    "foldedMin": 95,
    "foldedMax": 100,
    "unfoldedMax": null,
    "sourceGroup": "E-Twow Booster S+ / GT / SE",
    "aliases": [],
    "source": "existing-guide",
    "verifiedIndependent": false,
    "handlebarWidthCm": null,
    "handlebarWidthSource": null
  },
  {
    "brand": "ICe",
    "label": "ICe Q3 EVO 48V · VMP",
    "certification": "VMP (según fabricante)",
    "certificationSource": "https://icscooter.com/es/55-patinetes-certificados",
    "reviewedAt": "2026-09-08",
    "verifiedIndependent": false,
    "handlebarWidthSource": "Ancho total plegado publicado en el manual, usado conservadoramente como envolvente para el ajuste del manillar. No es una medición independiente del manillar.",
    "id": "ice-q3-evo-48v-certified",
    "name": "Q3 EVO 48V — certificado",
    "aliases": [
      "Q3 Evolution",
      "48V 15Ah",
      "48V 15.6Ah"
    ],
    "productUrl": "https://icscooter.com/es/patinetes-electricos-ice/404-ice-q3-evo-48v-15ah-dual-motor-1000w.html",
    "source": "official-manual",
    "dataStatus": "official-dimensions",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": 116,
    "overallFoldedWidthCm": 65,
    "handlebarWidthCm": 65,
    "foldedHeightCm": 50,
    "dimensionsSource": "https://icscooter.com/img/cms/MANUAL%20Q3%20EVO/MANUAL%20ESPA%C3%91OL%20Q3%20EVO.pdf",
    "sourcePage": 3,
    "sourceMeasurement": "116*65*123cm / Plegado: 116*65*50cm",
    "reviewNote": "Manual enlazado desde la ficha del modelo certificado. No aplicar a Q3 EVO 2026; no se importan otras especificaciones del manual."
  },
  {
    "brand": "ICe",
    "label": "ICe Q3 EVO ONE 52V · VMP",
    "certification": "VMP (según fabricante)",
    "certificationSource": "https://icscooter.com/es/55-patinetes-certificados",
    "reviewedAt": "2026-09-08",
    "verifiedIndependent": false,
    "handlebarWidthSource": "Ancho total plegado publicado en el manual, usado conservadoramente como envolvente para el ajuste del manillar. No es una medición independiente del manillar.",
    "id": "ice-q3-evo-one-52v-certified",
    "name": "Q3 EVO ONE 52V — certificado",
    "aliases": [
      "Q3 Evolution One",
      "52V 13Ah"
    ],
    "productUrl": "https://icscooter.com/es/patinetes-electricos-ice/403-ice-q3-evo-one-52v-13ah-1000w-max.html",
    "source": "official-manual",
    "dataStatus": "official-dimensions",
    "foldedMin": 116,
    "foldedMax": 116,
    "unfoldedMax": 116,
    "overallFoldedWidthCm": 65,
    "handlebarWidthCm": 65,
    "foldedHeightCm": 50,
    "dimensionsSource": "https://icscooter.com/img/cms/MANUAL%20Q3%20EVO%20ONE/MANUAL%20ESPA%C3%91OL%20Q3%20EVO%20ONE.pdf",
    "sourcePage": 3,
    "sourceMeasurement": "116*65*123cm / Plegado: 116*65*50cm",
    "reviewNote": "Manual enlazado desde la ficha del modelo certificado; dimensiones de esta versión, sin extrapolación a otras versiones."
  },
  {
    "brand": "ICe",
    "label": "ICe M5 48V · VMP",
    "certification": "VMP (según fabricante)",
    "certificationSource": "https://icscooter.com/es/55-patinetes-certificados",
    "reviewedAt": "2026-09-08",
    "verifiedIndependent": false,
    "handlebarWidthSource": null,
    "id": "ice-m5-48v-certified",
    "name": "M5 48V — certificado",
    "aliases": [
      "48V 15Ah",
      "48V 15.8Ah"
    ],
    "productUrl": "https://icscooter.com/es/patinetes-certificados/405-ice-m5-48v-15ah-dual-motor-1000w.html",
    "source": "official-product",
    "dataStatus": "dimensions-pending",
    "foldedMin": null,
    "foldedMax": null,
    "unfoldedMax": null,
    "handlebarWidthCm": null,
    "reviewNote": "Certificado en ficha y categoría oficial. No se han localizado dimensiones ni manual enlazado en la ficha revisada. No importar las de versiones parecidas."
  },
  {
    "brand": "ICe",
    "label": "ICe Q3 EVO 2026 48V · VMP",
    "certification": "VMP (según fabricante)",
    "certificationSource": "https://icscooter.com/es/55-patinetes-certificados",
    "reviewedAt": "2026-09-08",
    "verifiedIndependent": false,
    "handlebarWidthSource": null,
    "id": "ice-q3-evo-2026-48v-certified",
    "name": "Q3 EVO 2026 48V — certificado",
    "aliases": [
      "10 pulgadas",
      "48V 15Ah",
      "48V 15.6Ah"
    ],
    "productUrl": "https://icscooter.com/es/patinetes-electricos-ice/475-ice-q3-evo-2026-48v-15ah-dual-motor-1000w.html",
    "source": "official-product",
    "dataStatus": "dimensions-pending",
    "foldedMin": null,
    "foldedMax": null,
    "unfoldedMax": null,
    "handlebarWidthCm": null,
    "reviewNote": "Certificado en ficha y categoría oficial. No se han localizado medidas propias de 2026. El manual Q3 EVO anterior no prueba las de esta versión."
  },
  {
    "brand": "ICe",
    "label": "ICe Q5 EVO 2026 52V 23Ah · VMP",
    "certification": "VMP (según fabricante)",
    "certificationSource": "https://icscooter.com/es/55-patinetes-certificados",
    "reviewedAt": "2026-09-08",
    "verifiedIndependent": false,
    "handlebarWidthSource": null,
    "id": "ice-q5-evo-2026-52v-certified",
    "name": "Q5 EVO 2026 52V 23Ah — certificado",
    "aliases": [
      "Q5 Evolution 2026 52V"
    ],
    "productUrl": "https://icscooter.com/es/patinetes-electricos-ice/467-ice-q5-evo-2026-52v-23ah-dual-motor-1000w.html",
    "source": "official-product",
    "dataStatus": "dimensions-pending",
    "foldedMin": null,
    "foldedMax": null,
    "unfoldedMax": null,
    "handlebarWidthCm": null,
    "reviewNote": "Certificado en ficha y categoría oficial. No se han localizado dimensiones en ficha ni manual específico enlazado. No se usa el Q5 EVO no certificado."
  },
  {
    "brand": "ICe",
    "label": "ICe Q5 EVO 2026 60V 26Ah · VMP",
    "certification": "VMP (según fabricante)",
    "certificationSource": "https://icscooter.com/es/55-patinetes-certificados",
    "reviewedAt": "2026-09-08",
    "verifiedIndependent": false,
    "handlebarWidthSource": null,
    "id": "ice-q5-evo-2026-60v-certified",
    "name": "Q5 EVO 2026 60V 26Ah — certificado",
    "aliases": [
      "Q5 Evolution 2026 60V"
    ],
    "productUrl": "https://icscooter.com/es/patinetes-electricos-ice/469-ice-q5-evo-2026-60v-26ah-dual-motor-1000w.html",
    "source": "official-product",
    "dataStatus": "dimensions-pending",
    "foldedMin": null,
    "foldedMax": null,
    "unfoldedMax": null,
    "handlebarWidthCm": null,
    "reviewNote": "Certificado en ficha y categoría oficial. No se han localizado dimensiones en ficha ni manual específico enlazado. No se trasladan las de otro voltaje."
  }
];
